import { PaymentStatus, ScheduleType } from '@bybeam/platform-types';
import ContactInfo from '@platform-ui-common/components/ContactInfo/index.js';
import UsioContact from '@platform-ui-common/components/UsioContact/index.js';
import useFulfillment from '@platform-ui-common/hooks/contexts/useFulfillment.js';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import { findLatestPayment } from '@platform-ui-common/utilities/payment.js';
import { isPrepaidCard } from '@platform-ui-common/utilities/paymentMethods.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';

function PartnerContact(): JSX.Element {
  const { email, phone } = usePartner();
  const { scheduleType } = useFulfillment();

  return (
    <>
      If you have any questions or concerns about{' '}
      {scheduleType === ScheduleType.OneTime ? 'this payment' : 'these payments'}, please contact{' '}
      <ContactInfo email={email} phone={phone} />.
    </>
  );
}

export default function ContactInfoMessage(): JSX.Element {
  const {
    payments,
    payments: [firstPayment],
    scheduleType,
  } = useFulfillment();
  const { user } = useAuth();

  const latestPayment = findLatestPayment(payments);
  const payment = latestPayment ?? firstPayment;
  const latestPaymentSucceeded = latestPayment && latestPayment?.status !== PaymentStatus.Failed;

  switch (true) {
    // payments to a vendor or another party
    case user?.core?.id !== payment.payee.id:
    case !isPrepaidCard(payment.method):
    // recurring payments - display contact partner for prepaid only if the latest payment failed
    case scheduleType === ScheduleType.Recurring && !latestPaymentSucceeded:
      return <PartnerContact />;
    default:
      return (
        <>
          If you have questions regarding your prepaid card, please reach out to <UsioContact />.
        </>
      );
  }
}
